<template>
    <Header :class="{ 'color-primaryColor': !isHomePage }" />
    <div :class="{ 'bg-themBgColor': isHomePage, 'bg-[#F8F9FA]': isCommunityIssuesPage, 'bg-#fff': !isHomePage && !isCommunityIssuesPage }">
        <router-view />
    </div>
    <Footer />
</template>
<script setup lang="ts">
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import { setRem } from '@/responsive';
const { currentRoute } = useRouter();
const isHomePage = computed(() => currentRoute.value.path === '/home');
const isCommunityIssuesPage = computed(() => currentRoute.value.path === '/community');
</script>
